import { Skeleton } from '@pm/ui';
import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '@/lib/auth';

function BootSkeleton() {
  return (
    <div className="grid min-h-screen grid-cols-[var(--sidebar-w)_1fr] bg-bg">
      <div className="border-r border-border p-3">
        <Skeleton className="mb-6 h-6 w-32" />
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} className="mb-3 h-4 w-40" />
        ))}
      </div>
      <div className="p-page">
        <Skeleton className="mb-6 h-6 w-48" />
        <Skeleton className="mb-3 w-full" />
        <Skeleton className="mb-3 w-3/4" />
      </div>
    </div>
  );
}

/** Área autenticada. Sem organização ativa e com várias disponíveis → seleção. */
export function RequireAuth() {
  const { state } = useAuth();
  const location = useLocation();

  if (state.status === 'loading') return <BootSkeleton />;
  if (state.status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  const needsOrg = !state.me.organization && location.pathname !== '/select-organization';
  if (needsOrg) return <Navigate to="/select-organization" replace />;
  return <Outlet />;
}

export function RequireAnonymous() {
  const { state } = useAuth();
  if (state.status === 'loading') return <BootSkeleton />;
  if (state.status === 'authenticated') return <Navigate to="/" replace />;
  return <Outlet />;
}
